import { Component, OnInit, ViewChild } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import { LicensingModal } from '../licensing/licensing-modal.component';
import { ModalLicensingArgs } from '../licensing/modal-licensing-args';
import { tos, tosName, tosPath } from '../licensing/tos';
import { UserPreferencesService } from '../user/preferences.service';
import { User } from '../user/user';
import { UserService } from '../user/user.service';
import { UserLogin } from './user-login';
import { LoginService } from './user-login.service';
import { AwsEnvironment } from '../aws/environment';

/*
const AUSTIN_IMG = require('../../assets/login/austin.jpg');
const BUCHAREST_IMG = require('../../assets/login/bucharest.jpg');
const KOLKATA_IMG = require('../../assets/login/kolkata.jpg');
const LOSANGELES_IMG = require('../../assets/login/losangeles.jpg');
const PORTLAND_IMG = require('../../assets/login/portland.jpg');
const SANTACLARA_IMG = require('../../assets/login/santaclara.jpg');
const VANCOUVER_IMG = require('../../assets/login/vancouver.jpg');

const BACKGROUND_IMGS = [AUSTIN_IMG, BUCHAREST_IMG, KOLKATA_IMG, LOSANGELES_IMG, PORTLAND_IMG, SANTACLARA_IMG, VANCOUVER_IMG]
*/
const GREEN_IMG = require('../../assets/login/GreenNoTex.png');
const BLUE_IMG = require('../../assets/login/BlueNoTex.png');
const PURPLE_IMG = require('../../assets/login/PurpleNoTx.png');

const BACKGROUND_IMGS = [GREEN_IMG, BLUE_IMG, PURPLE_IMG];

const ROTATE_INTERVAL = 120000;

const FADE_ANIMATION = 'fade-background 1s ease-in backwards';

export const IXIA_OFFICES = [{
    image: GREEN_IMG,
    city: '',
    address: ''
}, {
    image: BLUE_IMG,
    city: '',
    address: ''
}, {
    image: PURPLE_IMG,
    city: '',
    address: ''
}];


@Component({
    selector: 'user-login',
    templateUrl: './user-login.component.html',
    styleUrls: ['./user-login.component.scss',
        '../../../node_modules/bootstrap/dist/css/bootstrap.css']
})
export class UserLoginComponent implements OnInit {
    email: string;
    password: string;
    error: string;
    mousePointer: string = 'pointer';
    inputDisabled = false;
    backgroundImg: string;
    nextBackgroundImg: string;
    backgroundImgRotatorTimer: any;
    playAnimation = false;
    animation = 'none';
    city = '';
    address = '';
    forgotPasswordUrl = '';
   // signupUrl = '';

    @ViewChild(LicensingModal) private eulaModel: LicensingModal;
    constructor(
        private userService: UserService,
        private loginService: LoginService,
        private preferencesService: UserPreferencesService,
        private router: Router,
        private awsEnv: AwsEnvironment,
        private route: ActivatedRoute
    ) { }

    ngOnInit() {
        this.forgotPasswordUrl = this.awsEnv.getForgotPasswordUrl();
       // this.signupUrl = this.awsEnv.getSignupUrl();
        this.backgroundImg = BACKGROUND_IMGS[Math.floor(Math.random() * BACKGROUND_IMGS.length)];
        this.nextBackgroundImg = this.backgroundImg;
        this.setFooterDetails();
        this.backgroundImgRotatorTimer = setTimeout(() => { this.rotateBackgroundImage(); }, ROTATE_INTERVAL);
    }

    login() {
        this.error = null;
        this.mousePointer = 'wait';
        this.inputDisabled = true;
        this.loginService.login(new UserLogin(this.email, this.password))
            .subscribe(
            (user: User) => {
                this.loginService.userLoggedIn(true);
                if (this.backgroundImgRotatorTimer) {
                    clearTimeout(this.backgroundImgRotatorTimer);
                    this.backgroundImgRotatorTimer = null;
                }

                this.preferencesService.setDefault(user.Preferences);
                if (!user.Preferences.AgreedToEula) {
                    this.eulaModel.showDialog(new ModalLicensingArgs(tos, 'Terms Of Service', tosPath, tosName)).subscribe(
                        (value: boolean) => {
                            if (value === true) {
                                user.Preferences.AgreedToEula = true;
                                this.userLoggedIn(user);
                            }
                            else {
                                this.mousePointer = 'pointer';
                                this.inputDisabled = false;
                            }
                        }
                    );
                }
                else {
                    this.userLoggedIn(user);
                }
            },
            (error: string) => {
                this.error = error;
                this.mousePointer = 'pointer';
                this.inputDisabled = false;
            },
            () => {
            }
            );

    }

    forgotPassword() {
        window.open(this.awsEnv.getForgotPasswordUrl(), '_blank');
    }

    private userLoggedIn(user: User) {
        this.userService.setCurrentUser(user)
            .then(() => {
                this.router.navigate(['/dashboard']);
            })
            .catch(error => {
                this.error = error;
            });

    }

    private rotateBackgroundImage() {
        let crtIdx = BACKGROUND_IMGS.indexOf(this.backgroundImg) + 1;
        if (crtIdx >= BACKGROUND_IMGS.length) {
            crtIdx = BACKGROUND_IMGS.length - crtIdx;
        }

        let img = BACKGROUND_IMGS[crtIdx];

        var xhr = new XMLHttpRequest();
        xhr.onload = (ev: Event) => {
            if (xhr.readyState == 4) {
                if (xhr.status == 200) {
                    this.nextBackgroundImg = img;
                    this.animation = FADE_ANIMATION;
                    this.playAnimation = true;
                }
            }
        };
        xhr.onerror = (ev: Event) => {
            console.error(xhr.statusText);
        };
        xhr.open('GET', img, true);
        xhr.send();
    }

    onAnimationEnd(event: AnimationEvent) {
        if (event.animationName === 'fade-background') {
            this.backgroundImg = this.nextBackgroundImg;
            this.playAnimation = false;
            this.animation = 'none';
            this.setFooterDetails();
            this.backgroundImgRotatorTimer = setTimeout(() => { this.rotateBackgroundImage(); }, ROTATE_INTERVAL);
        }
    }

    private setFooterDetails() {
        for (let office of IXIA_OFFICES) {
            if (office.image == this.backgroundImg) {
                this.city = office.city;
                this.address = office.address;
                break;
            }
        }
    }

    signUp() {
        if (this.awsEnv.getShowFreeTrial()) {
            this.router.navigate(['trial']);
        } else {
            this.router.navigate(['no-trial']);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/login/user-login.component.ts